import {
    app,
    ojs,
    Runner,
    registerNodeDisposalCallback,
    removeNodeModifications,
} from "modular-openscriptjs";
import {
    closeDropdown,
    dom,
    Filter,
    FSEventEmitter,
    IdGenerator,
    openDropdown,
    Pipeline,
    Requester,
    toggleCollapse,
    openCollapse,
    closeCollapse,
    toggleAccordion,
    handleDragStart,
    tool,
} from "./fotastart";
import {
    closeModal,
    closeAllModals,
    closeOffcanvas,
    deepEqual,
    disposeBootstrapTree,
    fireEvent,
    formatDuration,
    getModalData,
    hideCanvas,
    hideModal,
    inform,
    leaveEchoChannel,
    listenToEchoEvent,
    openCustomerSupport,
    openModal,
    openCloseableModal,
    openOffcanvas,
    pageInfo,
    redirect,
    scrollToTop,
    sendEvent,
    showActionButton,
    stopListeningToEchoEvent,
    searchPlaceholder,
    setSearchQuery,
    unfreezeBodyWhenNoModalOrOffcanvas,
} from "./helpers";
import AppOffCanvas from "./components/Offcanvas/AppOffCanvas";
import { dc, uc, pc, gc } from "./ojs.contexts";
import { $e } from "./ojs.events";
import {
    sideNavItems,
    offcanvasNavItems,
    bottomNavItems,
} from "./declarations";

import { EchoEventListener } from "./classes/EchoEventListener";

const router = app("router");
const broker = app("broker");
const route = router;
const echoEventListener = new EchoEventListener();
const algoliaSearch = new AlgoliaSearch()
app().value("EchoEventListener", echoEventListener);
app().value("AlgoliaSearch", algoliaSearch);

pc.sideItems.value = sideNavItems;
pc.offCanvasItems.value = offcanvasNavItems;
pc.bottomItems.value = bottomNavItems;

tool.makeGlobal(
    [app, "app"],
    [fireEvent, "fireEvent"],
    [sendEvent, "sendEvent"],
    [showActionButton, "showActionButton"],
    [redirect, "redirect"],
    [inform, "inform"],
    [scrollToTop, "scrollToTop"],
    [hideCanvas, "hideCanvas"],
    [hideModal, "hideModal"],
    [pageInfo, "pageInfo"],
    [echoEventListener, "EchoEventListener"],
    [formatDuration, "formatDuration"],
    [deepEqual, "deepEqual"],
    [setSearchQuery, "setSearchQuery"],
    [tool, "tool"],
    [dom, "dom"],
    [IdGenerator, "IdGenerator"],
    [Requester, "Requester"],
    [Pipeline, "Pipeline"],
    [Filter, "Filter"],
    [FSEventEmitter, "FSEventEmitter"],
    [gc, "gc"],
    [uc, "uc"],
    [pc, "pc"],
    [dc, "dc"],
);

window.app = app;
window.router = router;
window.route = route;
window.openCustomerSupport = openCustomerSupport;
window.EchoEventListener = echoEventListener;

// Modal Functions
window.openModal = openModal;
window.openCloseableModal = openCloseableModal;
window.closeModal = closeModal;
window.closeAllModals = closeAllModals;
window.getModalData = getModalData;

// Offcanvas Functions
window.openOffcanvas = openOffcanvas;
window.closeOffcanvas = closeOffcanvas;

// Dropdown Functions
window.openDropdown = openDropdown;
window.closeDropdown = closeDropdown;

// Collapse Functions
window.toggleAccordion = toggleAccordion;
window.toggleCollapse = toggleCollapse;
window.openCollapse = openCollapse;
window.closeCollapse = closeCollapse;

// Draggable Functions
window.handleDragStart = handleDragStart;

registerNodeDisposalCallback(
    /**
     * @param {Node} node
     */
    (node) => {
        disposeBootstrapTree(node);
        removeNodeModifications(node);
    },
);

broker.on("ojs:routeChanged", () => {
    // Empty the search suggestions and invalidate any in-flight suggestion
    // requests so a late response can't re-render them on the new page.
    resetSearchSuggestions();

    let shouldReset = true;

    for (let route in dc.searchHandlingRoutes) {
        if (app("router").is(route)) {
            shouldReset = false;
            break;
        }
    }

    if (shouldReset) {
        searchPlaceholder("Search for anything...");
    }

    // if no modal is opened and no offcanvas is opened 
    // we need to ensure that body element is scrollable
    unfreezeBodyWhenNoModalOrOffcanvas();
});

const h = app("h");
ojs(AppOffCanvas);
h.AppOffCanvas({ parent: dom.id("canvas-root") });

import { Preferences } from "@capacitor/preferences";
import { api } from "./declarations";
import { getStore, saveUser, deleteFromStorage, empty, resetSearchSuggestions } from "./helpers";
import './firebase';
import AlgoliaSearch from "./classes/AlgoliaSearch";

const initAuth = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token");

    if (token) {
        await Preferences.set({ key: "auth_token", value: token });
        const url = new URL(window.location);
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url);
    } else {
        const { value } = await Preferences.get({ key: "auth_token" });
        token = value;
    }

    if (token) {
        api.token = token;
    }
};

const initUser = async () => {
    const user = await getStore("user");
    if (user) {
        gc.user.value = user;
        gc.auth.value = true;
    }
};

const verifySession = async () => {
    if (!api.token) return;

    const res = await api.get("/users/current", {}, { silent: true });

    if (res && !empty(res.data.user)) {
        gc.user.value = res.data.user;
        gc.auth.value = true;
        await saveUser(res.data.user);
    } else {
        await deleteFromStorage("auth_token");
        await deleteFromStorage("user");

        gc.user.value = {};
        gc.auth.value = false;
        api.token = null;

        broker.broadcast($e.system.needs.configReload);
    }
};

const bootSystem = async () => {
    try {
        await initAuth();
        await initUser();
        await verifySession();
    } catch (err) {
        console.error(err);
    }

    broker.broadcast($e.system.booted);
    router.listen();
};

bootSystem();
